const calculateDefaultRowValues = ({ companyData = {}, row = {}, tasksData = [], departmentOptions = [], locationOptions = [] }) => {
  let pClientId = null;
  let pProjectId = null;
  let pTaskId = null;
  let pItemId = null;
  let pTimeTypeId = null;
  let pDepartment = null;
  let pLocation = null;
  let pBillable = false;
  let taskObj = null;
  let pDepartmentObj = null;
  let pLocationObj = null;
  if (row.entries && row.entries.length > 0) {
    const firstRowEntry = row.entries[0];
    if (companyData.showCustom) {
      pClientId = firstRowEntry.confirmedClientId;
    }
    if (companyData.showProject) {
      pProjectId = firstRowEntry.confirmedProjectId;
    }
    if (companyData.showTask) {
      pTaskId = firstRowEntry.confirmedTaskId;
      taskObj = tasksData.find((t) => t.id === pTaskId);
    }
    if (companyData.showItem) {
      pItemId = firstRowEntry.confirmedItemId;
    }
    if (companyData.showTimeType) {
      pTimeTypeId = firstRowEntry.timeTypeId;
    }
    if (companyData.showDepartmentLocation) {
      pDepartmentObj = departmentOptions?.find((v) => {
        return !!firstRowEntry.dimensions?.find((d) => d.dimension_value_id === v.id);
      });
      pDepartment = pDepartmentObj?.id;
      pLocationObj = locationOptions?.find((v) => {
        return !!firstRowEntry.dimensions?.find((d) => d.dimension_value_id === v.id);
      });
      pLocation = pLocationObj?.id;
    }
    pBillable = firstRowEntry.billable;
  } else {
    if (row.dimensionValues) {
      if (companyData.showCustom) {
        pClientId = row.dimensionValues?.clientId;
      }
      if (companyData.showProject) {
        pProjectId = row.dimensionValues?.projectId;
      }
      if (companyData.showTask) {
        pTaskId = row.dimensionValues?.taskId;
      }
      if (companyData.showItem) {
        pItemId = row.dimensionValues?.itemId;
      }
      if (companyData.showTimeType) {
        pTimeTypeId = row.dimensionValues?.timeTypeId;
      }
      if (companyData.showDepartmentLocation) {
        pDepartment = row.dimensionValues?.departmentId;
        pLocation = row.dimensionValues?.locationId;
      }
      if (companyData.showBillable) {
        pBillable = row.dimensionValues?.billable;
      }
    } else {
      pBillable = taskObj && taskObj.billable;
    }
  }
  return {
    pBillable,
    pClientId,
    pDepartment,
    pDepartmentObj,
    pItemId,
    pLocation,
    pLocationObj,
    pProjectId,
    pTaskId,
    pTimeTypeId,
    taskObj,
  };
};

export { calculateDefaultRowValues };
